import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getExploitationCoordinateByDomain } from "../../Utils/exploitations/map";
import Loading from "../Shared/Loading";
import GeoKMLProcessor from "../../Hooks/map/GeoMarkProcessor";

const MapDomain = () => {
  const { domainId } = useParams();
  const [explois, setExplois] = useState([]);
  const [loading, setLoading] = useState(false);

  const getExploisByDomainId = async () => {
    setLoading(true);
    try {
      const res = await getExploitationCoordinateByDomain(domainId);
      const coordinates = res.data.map((item) => ({
        lng: parseFloat(item.coordinates?.split(", ")[0].replace("(", "")),
        lat: parseFloat(item.coordinates?.split(", ")[1].replace(")", "")),
        title: item.exploitation_name,
        exploitation_id: item.exploitation_id,
        exploitation: item,
      }));
      setExplois(coordinates);
    } catch (err) {
      setExplois([]);
      console.error(err);
    }
    setLoading(false);
  };


  useEffect(() => {
    getExploisByDomainId();
  }, [domainId]);

  return (
    <>
      {loading && <Loading />}
      {explois.length > 0 && (
        <GeoKMLProcessor markers={explois} isSolPoint={false} />
      )}
    </>
  );
};

export default MapDomain;
